import { hasQrCodeLink, PostQrCode } from "@package/ui-apollo-components";
import { useSelectorWall } from "@package/ui-redux";
import { MediaDisplay } from "@package/ui-wall-components";
import { get } from "lodash";
import { FlyoutRelatedPost } from "../../common/RelatedPosts/RelatedPosts";
import { type FlyoutProps } from "../../utils/flyout-props";

export function FlyoutEvent({ screen }: FlyoutProps) {
  const mediaBanner = get(
    screen.flyout?.post,
    "customData.flyoutEvent.mediaBanner",
    undefined,
  );
  const title = get(screen.flyout?.post, "customData.flyoutEvent.title", "");
  const body = get(screen.flyout?.post, "customData.flyoutEvent.body", "");
  const mediaBody = get(
    screen.flyout?.post,
    "customData.flyoutEvent.mediaBody",
    undefined,
  );
  const mediaLogo =
    get(screen.flyout?.post, "customData.flyoutEvent.mediaLogo") ??
    screen.flyout?.post?.relatedPostAsset ??
    undefined;
  const backgroundColorPrimary = get(
    screen.flyout?.post,
    "customData.flyoutEvent.primary.backgroundColor",
    "#000000",
  );
  const colorPrimary = get(
    screen.flyout?.post,
    "customData.flyoutEvent.primary.color",
    "#ffffff",
  );
  const location = useSelectorWall((state) => state.wall.location);
  const profile = useSelectorWall((state) => state.wall.profile);

  return (
    <div
      className="flex flex-col w-full h-full"
      style={{ backgroundColor: backgroundColorPrimary }}
    >
      <div className="flex-0 w-full">
        <MediaDisplay id={mediaBanner} forceFit />
      </div>
      <div className="flex-1 w-full flex flex-row min-h-0">
        <div className="flex-1 h-full flex flex-col">
          {!!title && (
            <div className="flex-0 w-full p-8">
              <div
                className="text-4xl font-bold text-center"
                style={{ color: colorPrimary }}
              >
                {title}
              </div>
            </div>
          )}
          <div className="flex-1 w-full pl-8 p-r8 pb-8 min-h-0 overflow-auto">
            <div
              className="text-4xl"
              style={{ color: colorPrimary }}
              dangerouslySetInnerHTML={{ __html: body }}
            />
          </div>
          <div className="flex-0 w-full">
            <MediaDisplay id={mediaBody} forceFit />
          </div>
        </div>
        <div
          className="flex-0 h-full flex flex-col justify-center items-center"
          style={{ maxWidth: "30%" }}
        >
          <div className="flex-0 w-full p-8">
            <MediaDisplay id={mediaLogo} />
          </div>
          <div className="flex-1 w-full flex flex-col justify-end items-end">
            <div className="flex-0 w-full flex flex-col justify-center items-center">
              <div className="p-4 bg-white rounded-2xl">
                {hasQrCodeLink(location, profile, screen?.flyout?.post) && (
                  <PostQrCode
                    location={location}
                    profile={profile}
                    post={screen?.flyout?.post}
                    size={172}
                  />
                )}
              </div>
            </div>
            <div className="flex-0 flex justify-center items-center">
              <div className="text-4xl p-4 font-bold text-center">
                {screen.flyout?.post?.qrCodeText ?? "SCAN FOR DETAILS"}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex-0 w-full">
        <FlyoutRelatedPost screen={screen} />
      </div>
    </div>
  );
}
